export const FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_REQUEST = 'FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_REQUEST'
export const FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_SUCCESS = 'FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_SUCCESS'
export const FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_FALUIRE = 'FETCH_LOAD_ALL_DOC_FOR_PROJECT_ASS_FALUIRE'
